import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { cancel, requestRecaptcha, requestApplication, requestPhoneCodes,
    submitRequest } from '../../../../actions/default-register'
import { addNotification } from '../../../../state/notifications'
import { selectErrorMessage,
    selectPhoneCodes,
    selectRecaptcha,
    selectRequestApplication,
    selectQuickRegister,
    selectStep,
    selectSubmitStatus } from '../../../../reducers/default-register'


const mapStateToProps = createStructuredSelector({
    errorMessage: selectErrorMessage,
    phoneCodes: selectPhoneCodes,
    recaptchaValue: selectRecaptcha,
    requestApplications: selectRequestApplication,
    stepNumber: selectStep,
    submitRequest: selectQuickRegister,
    submitStatus: selectSubmitStatus
})

const mapDispatchToProps = dispatch => {
    return {
        onCancel: () => dispatch(cancel()),
        onRequestApplication: () => dispatch(requestApplication()),
        onRequestPhoneCodes: () => dispatch(requestPhoneCodes()),
        onRequestRecaptcha: () => dispatch(requestRecaptcha()),
        onAddNotification: payload => dispatch(addNotification(payload)),
        onSubmitRequest: values => dispatch(submitRequest(values))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)
